import { Listbox, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { FiCheck, FiChevronDown as ArrowDownIcon } from 'react-icons/fi'
import { useStore } from "../contexts/Store.context"

export default function Select({ name, label, control, width, fullWidth, type, setValue, initialOptions, initialValue }) {
    const options = initialOptions ?? optionsList(type)
    const initial = options.find(op => op.value === initialValue) ?? options[0]
    const [selectedOption, setSelectedOption] = useState(initial)

    useEffect(() => {
        setValue?.(selectedOption.value)
        //eslint-disable-next-line
    }, [selectedOption])

    return (
        <div className="relative z-40">
            <Controller
                name={name}
                control={control ?? {}}
                defaultValue={initialValue}
                render={({ onChange }) =>
                    <Listbox value={selectedOption} onChange={e => {
                        onChange(e.value)
                        setSelectedOption(e)
                    }}>
                        {({ open }) => (
                            <>
                                {label && <Listbox.Label className="block text-sm leading-5 text-gray-500 mb-2">{label}</Listbox.Label>}

                                <span className={`inline-block shadow-sm rounded-lg ${fullWidth ? "w-full" : (width ?? "w-60")}`}>
                                    <Listbox.Button className={`h-12 menu-button px-4 flex items-center justify-between cursor-default capitalize
                                        border border-blue-300 bg-blue-50 text-left focus:outline-none focus:shadow-outline-blue 
                                        focus:ring-4 focus:ring-blue-200 text-sm md:text-base sm:leading-5 
                                        ${fullWidth ? "w-full" : (width ?? "w-60")} h-10 md:h-12 rounded-lg`
                                    }>
                                        <span className="truncate text-blue-800 capitalize">{selectedOption.label ?? selectedOption.value}</span>
                                        <ArrowDownIcon className="text-blue-300 w-6 h-6" />
                                    </Listbox.Button>
                                </span>

                                <Transition
                                    show={open}
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                    className="absolute mt-1 w-full rounded-md bg-white shadow-lg z-10"
                                >
                                    <Listbox.Options className={`absolute right-0 top-1 max-h-60 oveflow-x-hidden focus:outline-none sm:text-sm sm:leading-5
                                        overflow-y-auto scrollbar rounded-md flex flex-col border border-blue-200 bg-white shadow-md
                                        ${width ?? "w-60"}
                                    `}>
                                        {
                                            options.map((option, i) => {
                                                const isSelected = selectedOption.value === option.value
                                                /* Use the `active` state to conditionally style the active option. */
                                                /* Use the `selected` state to conditionally style the selected option. */
                                                return <Listbox.Option as={Fragment} key={i} value={option}>
                                                    {({ active }) => (
                                                        <div className={`menu-item flex items-center px-4 py-2 md:py-3 cursor-default select-none
                                                            ${active && !isSelected ? "bg-blue-50" : ""} ${isSelected ? "bg-blue-200 text-blue-800" : "text-gray-500"}  
                                                        `}>
                                                            {isSelected ? <FiCheck className="mr-2 w-5 h-5" /> : null}
                                                            <span className={`block truncate text-sm capitalize ${isSelected && "font-medium"}`}>{option.label ?? option.value}</span>
                                                        </div>
                                                    )}
                                                </Listbox.Option>
                                            })
                                        }
                                    </Listbox.Options>
                                </Transition>
                            </>
                        )}
                    </Listbox>
                }
            >
            </Controller>
        </div>
    )
}

export function CustomersSelect() {
    const { control } = useForm()
    const { allCustomers, setCurrentUser } = useStore()
    const selectOptions = allCustomers?.map(cus => ({ label: `${cus.first_name} ${cus.last_name}`, value: cus }))

    return (
        <Select
            name="user"
            control={control}
            initialOptions={selectOptions}
            setValue={setCurrentUser}
            style={{ width: 240 }}
            fullWidth
        />
    )
}

function optionsList(type) {
    switch (type) {
        case "dates": return [
            { value: 7, label: `Last 7 Days` },
            { value: 14, label: `Last 14 Days` },
            { value: 30, label: `Last 30 Days` },
            { value: 190, label: `Last 90 Days` },
            { value: "week", label: `This Week` },
            { value: "month", label: `This Month` },
            { value: "year", label: `This Year` },
        ]
        case "states": return [
            { value: "lagos", label: "Lagos" },
            { value: "abuja", label: "Abuja" },
            { value: "ogun", label: "Ogun" },
            { value: "oyo", label: "Oyo" },
            { value: "port harcourt", label: "Port Harcourt" },
            { value: "osun", label: "Osun" },
        ]
        default:
            return [
                { value: "success", label: "Success" },
                // { value: "abandoned", label: "Abandoned" },
                { value: "failed", label: "Failed" },
            ]
    }
}